import { inject } from '@angular/core';
import {
  Router,
  CanActivateFn,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { URLS } from '@constants/urls';
import { FIRST_ACCESS_WIZARD_LAST_STEP } from '@pages/login/wizard-first-access/wizard-first-access.component';
import { CognitoService } from '@services/cognito/cognito.service';
import { PermissionsService } from '@services/user/permissions.service';

export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const cognitoService = inject(CognitoService);
  const router = inject(Router);
  const permissionsService = inject(PermissionsService);

  const excludedRoutes = [
    `${URLS.BASE}${URLS.LOGIN}`,
    `${URLS.BASE}${URLS.SIGNUP}`,
  ];

  let baseUrl = decodeURIComponent(state.url.split('?')[0]).replace(/\/+$/, '');
  const isExcludedRoute = excludedRoutes.includes(baseUrl);

  const isFirstAccessRoute =
    baseUrl === `${URLS.BASE}${URLS.FIRST_ACCESS_WIZARD}`;

  // IMPORTANTE: Controlla l'autenticazione in modo asincrono
  const isAuthenticated = await cognitoService.checkAuthenticationStatus();

  if (isAuthenticated) {
    const wizardCompleted =
      cognitoService.wizardStep().step === FIRST_ACCESS_WIZARD_LAST_STEP;

    if (isExcludedRoute || (isFirstAccessRoute && wizardCompleted)) {
      router.navigate([`${URLS.BASE}`]);
      return false;
    }

    const urlKey = Object.keys(URLS).find((key) => {
      const segments = baseUrl.split('/');
      return segments[1]
        ? URLS[key as keyof typeof URLS] === segments[1]
        : false;
    }) as keyof typeof URLS;

    if (
      urlKey &&
      !permissionsService.canView(urlKey) &&
      urlKey !== 'REPORT_TEMPLATE_PRINT_PAGE'
    ) {
      router.navigate([URLS.BASE, URLS.UNAUTHORIZED]);
      return false;
    }
    return true;
  } else {
    if (isExcludedRoute) {
      console.log('User not authenticated, accessing excluded route:', baseUrl);
      return true;
    }
    console.log('User not authenticated, redirecting to login');
    return router.parseUrl(`${URLS.BASE}${URLS.LOGIN}`);
  }
};
